import { request } from '@kmi/react';
import type * as model from './models';

/** auth-controller 是否有私有建模权限 */
export function authGet(options?: { [key: string]: any }) {
    return request<model.SimpleResultboolean>(`/sp/model/account/auth`, {
        method: 'get',
        ...(options || {}),
    });
}
